import React from 'react';

const IdVat = ({
    postedDate,
    isPetsOrPhones,
    id,
    vatNumber,
}: {
    postedDate: string | undefined;
    isPetsOrPhones: boolean;
    id?: number;
    vatNumber?: string;
}) => {
    const showPostedDate = postedDate && isPetsOrPhones;
    return (
        <>
            {showPostedDate && (
                <p style={{ marginBottom: 0 }}>
                    Posted: <b>{postedDate}</b>
                </p>
            )}
            {id && (
                <p
                    data-q="vip-adid"
                    style={{ marginBottom: 0, ...(showPostedDate ? { marginTop: 0 } : {}) }}
                >
                    Ad ID: <b itemProp="sku">{id}</b>
                </p>
            )}
            {vatNumber && (
                <span data-q="ad-price-vat">
                    VAT number: <b>{vatNumber}</b>
                </span>
            )}
        </>
    );
};

export default IdVat;
